import ListIcon from '@material-ui/icons/ViewList';
import PaymentGatewayConfigurationHistoryList from "./PaymentGatewayConfigurationHistoryList";


export default {
    list: PaymentGatewayConfigurationHistoryList,
    icon: ListIcon,
};
